document.addEventListener("DOMContentLoaded", function () {
    const accordions = document.querySelectorAll('.inner-accordian');

    accordions.forEach((accordion) => {
      const heading = accordion.querySelector('.acc-heading');
      const content = accordion.querySelector('.acc-content');
      const plusIcon = accordion.querySelector('.icon-plus');
      const minusIcon = accordion.querySelector('.icon-minus');

      heading.addEventListener('click', function () {
        const isOpen = content.style.display === 'block';

        // Toggle content
        content.style.display = isOpen ? 'none' : 'block';

        // Toggle icons
        plusIcon.style.display = isOpen ? 'inline-block' : 'none';
        minusIcon.style.display = isOpen ? 'none' : 'inline-block';
      });
    });
  });

  
document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
      if (Shopify.designMode) {
        document.documentElement.classList.add('shopify-design-mode');
      }
      document.documentElement.style.setProperty('--viewport-height', window.visualViewport.height + 'px');
      document.documentElement.style.setProperty('--viewport-width', window.visualViewport.width + 'px');
 
      
      function getBroswerDetails() {
        //Checking the user's OS and Browser
        if ((navigator.userAgent).includes("Android")) {
            document.querySelector("html").classList.add("android");
        } else if ((navigator.userAgent).includes("Mac")) {
            document.querySelector("html").classList.add("mac");
        } else {
            document.querySelector("html").classList.add("windows");
        }
    
    
        //-- Browser --//
        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        var isFirefox = typeof InstallTrigger !== 'undefined';
        var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
            return p.toString() === "[object SafariRemoteNotification]";
        })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
        var isIE = /*@cc_on!@*/ false || !!document.documentMode;
        var isEdge = !isIE && !!window.StyleMedia;
        var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
        var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
        var isBlink = (isChrome || isOpera) && !!window.CSS;
        if (isFirefox) {
            document.querySelector("html").classList.add("isFirefox")
        } else if (isChrome) {
            document.querySelector("html").classList.add("isChrome")
        } else if (isSafari) {
            document.querySelector("html").classList.add("isSafari")
        } else if (isOpera) {
            document.querySelector("html").classList.add("isOpera")
        } else if (isIE) {
            document.querySelector("html").classList.add("isIE")
        } else if (isEdge) {
            document.querySelector("html").classList.add("isEdge")
        } else if (isEdgeChromium) {
            document.querySelector("html").classList.add("isEdgeChromium")
        } else {
            document.querySelector("html").classList.add("isBlink")
        }
    }
  getBroswerDetails();

  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    // true for mobile device
    document.querySelector("html").classList.add("mobile");
  }

//  Multiple Videos Autoplay When in Viewport
  document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".product-card__media video");

  if (!videos.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      if (entry.isIntersecting) {
        // Play when visible (resume from paused time)
        if (video.paused) {
          video.play().catch(() => {});
        }
      } else {
        // Pause when out of view (but do not reset)
        if (!video.paused) {
          video.pause();
        }
      }
    });
  }, {
    threshold: 0.5 // 50% visible triggers play
  });

  videos.forEach(video => {
    video.muted = true; // autoplay compliance
    video.playsInline = true;
    video.loop = true; // loop when ended
    video.autoplay = false;
    observer.observe(video);
  });
});
